import { isMobileViewport } from "../utils/viewport.js";

function scrollToMobileSwatches(): void {
  const swatches = document.querySelector<HTMLElement>(".Product_swatch_colors");
  if (!swatches) return;

  const headerVar = getComputedStyle(document.documentElement)
    .getPropertyValue("--theme-sticky-header-height")
    .trim();
  const headerHeight = parseInt(headerVar, 10) || 0;
  swatches.style.scrollMarginTop = `${Math.ceil(headerHeight + 8)}px`;
  swatches.scrollIntoView({ block: "start", behavior: "smooth" });
}

export function initBackToTopHandler(): void {
  $(document).on("click", ".back_to_top--right", function (e: JQuery.ClickEvent) {
    if (!isMobileViewport()) return;

    e.preventDefault();
    scrollToMobileSwatches();
  });
}
